import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
const useEnrollResidentStyles = makeStyles(_objectSpread(_objectSpread({}, sections), {}, {
  contentBlock: {
    backgroundColor: palette.common.white,
    boxShadow: palette.shadows.light,
    marginBottom: '10px',
    padding: '24px 40px',
    position: 'relative'
  },
  contentBlock2: {
    backgroundColor: palette.common.white,
    boxShadow: palette.shadows.light,
    marginBottom: '10px',
    position: 'relative'
  },
  contentOccupancyBlock: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between'
  },
  contentWrapper: {
    height: '580px',
    overflowY: 'scroll',
    marginRight: '-55px',
    paddingRight: '40px',
    position: 'relative'
  },
  controllers: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '0'
  },
  // customAddressFormSwitch: {
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'flex-start',
  // },
  // customAddressRequest: {
  //   padding: '16px',
  //   borderRadius: '2px',
  //   backgroundColor: palette.info.light,
  //   border: '1px solid #2A85D1',
  // },
  // customAddressRequestActions: {
  //   display: 'flex',
  //   marginTop: '24px',
  //   alignItems: 'center',
  //   justifyContent: 'space-between',
  // },
  // customAddressFormCaption: {
  //   paddingLeft: '49px',
  //   marginBottom: '24px',
  // },
  customAddressList: {
    marginTop: '24px',
    marginBottom: '16px'
  },
  customAddressListItem: {
    borderRadius: '2px',
    '&:not(:last-child)': {
      marginBottom: '16px'
    },
    '&.request': {
      padding: '4px 4px',
      backgroundColor: palette.info.light
    }
  },
  customAddressListItemWrapper: {
    display: 'flex',
    padding: '8px 12px',
    alignItems: 'center',
    border: "1px solid ".concat(palette.shades[300]),
    justifyContent: 'space-between',
    backgroundColor: palette.common.white
  },
  customAddressListItemDetails: {
    width: '100%',
    paddingLeft: '8px',
    '& b': {
      display: 'block',
      fontWeight: '600',
      fontSize: '14px'
    },
    '& span': {
      display: 'block',
      fontSize: '13px',
      color: palette.shades[700]
    }
  },
  customAddressListItemControllers: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiChip-root': {
      fontWeight: '600'
    },
    '& .MuiButton-root': {
      padding: '6px 8px',
      color: palette.shades[700],
      backgroundColor: palette.shades[200],
      '& path': {
        fill: palette.shades[700]
      },
      '&.Mui-disabled': {
        opacity: 0.5
      }
    }
  },
  // customAddressListItemCaption: {
  //   display: 'flex',
  //   padding: '12px',
  //   alignItems: 'center',
  //   justifyContent: 'space-between',
  // },
  // customAddressListItemCaptionData: {
  //   fontSize: '13px',
  //   fontWeight: '600',
  //   color: palette.info.dark,
  // },
  // customAddressListItemCaptionControllers: {
  //   display: 'flex',
  //   flexShrink: '0',
  //   alignItems: 'center',
  // },
  customAddressListItemDetailsActions: {
    display: 'flex',
    marginLeft: '8px',
    alignItems: 'center',
    '& > div + button': {
      marginLeft: '8px'
    }
  },
  modalContent: {
    overflow: 'hidden',
    padding: '0 40px 38px 40px'
  },
  tabContent: {
    padding: '32px 40px 40px 40px'
  }
}));
export default useEnrollResidentStyles;